export const COMPOSE = 'compose';

export const types = [COMPOSE];